import React from "react";

import { coerceRuntimeParamValue, getRuntimeFields } from "../lib/strategyRuntime";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Switch } from "./ui/switch";

export default function StrategyRuntimeFields({
  engine,
  params = {},
  onChange,
  gridClassName = "grid grid-cols-1 gap-3 md:grid-cols-2",
  fieldClassName = "space-y-2",
  labelClassName = "text-sm font-medium text-zinc-300",
  inputClassName = "border-zinc-700 bg-zinc-800 text-sm text-white",
  switchCardClassName = "flex items-center justify-between rounded-md border border-zinc-800 bg-zinc-950/60 px-3 py-3",
  hintClassName = "text-xs text-zinc-500",
  showDescriptions = true,
}) {
  const fields = getRuntimeFields(engine);
  if (!fields.length) {
    return null;
  }

  return (
    <div className={gridClassName}>
      {fields.map((field) => {
        if (field.type === "boolean") {
          return (
            <div key={field.key} className={switchCardClassName}>
              <div className="space-y-1 pr-3">
                <Label className={labelClassName}>{field.label}</Label>
                {showDescriptions && field.description ? <p className={hintClassName}>{field.description}</p> : null}
              </div>
              <Switch
                checked={Boolean(params?.[field.key])}
                onCheckedChange={(checked) => onChange(field.key, checked)}
              />
            </div>
          );
        }

        return (
          <div key={field.key} className={fieldClassName}>
            <Label className={labelClassName}>{field.label}</Label>
            <Input
              type={field.type || "number"}
              value={params?.[field.key] ?? ""}
              min={field.min}
              max={field.max}
              step={field.step}
              onChange={(event) => onChange(field.key, coerceRuntimeParamValue(field, event.target.value))}
              className={inputClassName}
            />
            {showDescriptions && field.description ? <p className={hintClassName}>{field.description}</p> : null}
          </div>
        );
      })}
    </div>
  );
}
